module.exports = __webpack_public_path__ + "img/taskchat-btn_date_set.fef6a1ed.svg";